import Header from "@/layouts/Header/Header";
import DashboardSidebar from "./dashboard-sidebar";
import { useEffect, useState } from "react";
import "./layout.scss";
import { useSidebarStore } from "@/context";
import { Outlet } from "react-router-dom";

// import "@mantine/core/styles.layer.css";
// import "mantine-datatable/styles.layer.css";
// import "./layout.css";

export default function DashboardLayout() {
  const { isDashSidebarOpen } = useSidebarStore();

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    document.body.style.backgroundColor = "#e4e2d7";
  }, []);
  return (
    <>
      <Header />
      <div
        className={`dashboard-layout-container ${
          isDashSidebarOpen ? "show-sidebar" : ""
        } ${isMobile ? "is-mobile" : ""} ${
          isDashSidebarOpen ? "sidebar-open" : "sidebar-closed"
        }`}
      >
        <div className={`dashboard-sidebar-container`}>
          <DashboardSidebar />
        </div>
        <main className="dashboard-layout-main">
          <Outlet />
        </main>
      </div>
    </>
  );
}
